import { combineReducers } from 'redux'
import { updateSearchTerm } from 'store/searchTerm'
import request from 'utils/request'
import moment from 'moment'
import { ACCESS_INFO_MAP } from '../../CreateUser/components/CreateUserPage'

//
// Actions
//

const FETCHED_USERS = 'FETCHED_USERS'

//
// Action Creators
//

// Fetches the user list and maps the users that are sub-users of the currently logged in user

export const fetchUsers = () => {
  return dispatch => {
    const success = json => {
      dispatch({
        type: FETCHED_USERS,
        payload: json.users
      })
    }
    return dispatch(
      request({
        url: '/control/users',
        success,
        hasLoader: true
      })
    )
  }
}

const formatUserList = list => {
  return list.map(({ username, role, last_login, nickname, id }) => {
    const lastLogin = last_login ? moment(last_login) : last_login
    const _role = role === 'edit' ? 'administrator' : role
    return [
      { key: 'nickname', value: nickname, sortValue: nickname, id },
      { key: 'email', value: username, sortValue: username },
      { key: 'role', value: ACCESS_INFO_MAP[_role].text, sortValue: role },
      {
        key: 'lastLogin',
        value: lastLogin ? lastLogin.format('LL') : 'Never Logged In',
        sortValue: lastLogin ? lastLogin.valueOf() : 0
      }
    ]
  })
}

//
// Reducers
//

const list = (state = [], action) => {
  switch (action.type) {
    case FETCHED_USERS:
      return formatUserList(action.payload)
    default:
      return state
  }
}

export default combineReducers({
  list
})

export const actions = {
  fetchUsers,
  updateSearchTerm
}
